// api.js
import axios from 'axios';


// 创建 axios 实例
const service = axios.create({
    baseURL: 'http://gnxz.bmxgj.cn',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 请求拦截器（可选，比如加 token）
service.interceptors.request.use(
    config => {
        // 可以统一加 token
        // config.headers['Authorization'] = 'Bearer ' + token;
        return config;
    },
    error => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 自动拆 business data
        const bizData = response?.data?? null;

        // 如果接口异常返回 code !== 200，也可以统一抛错
        if (response?.data?.data?.code && response.data.data.code !== 200) {
            return Promise.reject(new Error(response.data.data.msg || '接口异常'));
        }

        return bizData; // 直接返回业务层 data
    },
    error => {
        console.error('接口调用失败:', error);
        return Promise.reject(error);
    }
);

export default service;
